import { render, staticRenderFns } from "./BlackListHome.vue?vue&type=template&id=659019d0&scoped=true"
import script from "./BlackListHome.vue?vue&type=script&lang=js"
export * from "./BlackListHome.vue?vue&type=script&lang=js"
import style0 from "./BlackListHome.vue?vue&type=style&index=0&id=659019d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659019d0",
  null
  
)

export default component.exports